import { getLogger } from '@/shared-components-web/logging/logger';
interface AnalyticsGtmProps {
  uniqueTrackingValue: string;
  pagePath?: string;
}
const logger = getLogger('design-system');
export const GTMAnalytics = ({
  uniqueTrackingValue,
  pagePath
}: AnalyticsGtmProps) => {
  logger.info(`GTM ANALYTICS CREATED for ${pagePath ?? 'unknown path'}`);
  return (
    // eslint-disable-next-line react/no-danger, @next/next/next-script-for-ga
    <script dangerouslySetInnerHTML={{
      __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
			new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
			j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
			'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','${uniqueTrackingValue}');`
    }} data-sentry-component="GTMAnalytics" data-sentry-source-file="GTMAnalytics.tsx" />
  );
};